import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css';
import 'jquery';
import 'jquery-csv';
import 'bootstrap';

import 'mf-shared/styles/tailwind.css';
import 'mf-shared/styles/main.css';

import './tracker';
import './interceptor';

import { setDefaultResponsiveMode } from 'mf-shared/utils/fullSite';

// FIXME A mysterious way to determine mobile vs desktop mode.
// It is supposed to be a UI concern, so it should be handled inside
// the React component tree.
setDefaultResponsiveMode();
